import {fromJS} from 'immutable';

/* eslint-disable max-len, import/prefer-default-export */
export const navLinks = fromJS([
  {
    name: 'Explore',
    dropdown: [
      {
        name: 'For Teachers',
        hardLink: true,
        route: '/solutions-teachers'
      },
      {
        name: 'For Admins',
        hardLink: true,
        route: '/solutions-admins'
      },
      {
        name: 'Albert Adaptive | Early Access',
        hardLink: true,
        route: '/solutions/albert-adaptive'
      },
      {
        name: 'Testimonials',
        hardLink: true,
        route: '/solutions/testimonials'
      },
      {
        name: 'Case Studies',
        hardLink: true,
        route: '/case-studies'
      },
      {
        name: 'Professional Development',
        hardLink: true,
        route: '/solutions/professional-development'
      }
    ]
  },
  {
    name: 'Library'
  },
  {
    name: 'Pricing',
    hardLink: true,
    route: '/pricing-schools'
  }
]);
/* eslint-disable max-len */
